
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface TimeRangeSelectorProps {
  timeRange: string;
  setTimeRange: (value: string) => void;
}

export function TimeRangeSelector({ timeRange, setTimeRange }: TimeRangeSelectorProps) {
  const { language } = useLanguage();
  
  return (
    <Select value={timeRange} onValueChange={setTimeRange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder={t('statistics.selectTimeRange', language)} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="1month">{t('statistics.lastMonth', language)}</SelectItem>
        <SelectItem value="3months">{t('statistics.lastThreeMonths', language)}</SelectItem>
        <SelectItem value="6months">{t('statistics.lastSixMonths', language)}</SelectItem>
        <SelectItem value="1year">{t('statistics.lastYear', language)}</SelectItem>
        <SelectItem value="all">{t('statistics.allTime', language)}</SelectItem>
      </SelectContent>
    </Select>
  );
}
